'use strict';
function getMyDetails() {
    $.ajax({
        url: '/api/fvmember/my-details',
        type: "GET",        
        contentType: "application/json",
        success: function(data) {

            //$("#MyDetailsTitle").val(data.Data.Title);
            //$("#MyDetailsFirstName").val(data.Data.FirstName);
            //$("#MyDetailsLastName").val(data.Data.LastName);
            //$("#MyDetailsEmail").val(data.Data.Email);

        }        
    });
}